import { render, staticRenderFns } from "./ProductDivision.vue?vue&type=template&id=66582048&"
import script from "./ProductDivision.vue?vue&type=script&lang=js&"
export * from "./ProductDivision.vue?vue&type=script&lang=js&"
import style0 from "./ProductDivision.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports